import { useCallback } from 'react';
import { Trans } from 'react-i18next';
import { TransLink } from 'components/text/TransLink';

const useGetLoginErrorMessage = () => {
  return useCallback(
    ({
      errorCode,
      subscriptionManagementLink,
      subscriptionPaymentDueDays,
    }: {
      errorCode: string;
      subscriptionManagementLink: string | undefined;
      subscriptionPaymentDueDays: number | undefined;
    }) => {
      return (
        <Trans
          i18nKey="pageLogin.error"
          context={errorCode}
          values={{ dueDays: subscriptionPaymentDueDays }}
          components={{
            managementLink: (
              <TransLink
                href={subscriptionManagementLink}
                rel="noreferrer"
                target="_blank"
              />
            ),
            billingMail: <TransLink href="mailto:billing@hostfully.com" />,
          }}
        />
      );
    },
    [],
  );
};

export default useGetLoginErrorMessage;
